var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"imageStatic"},[_c('div',{staticClass:"user-card"},[_c('div',{staticClass:"image_area"},[_c('img',{staticClass:"user-card__picture mx-auto",attrs:{"src":_vm.imgUrl},on:{"error":_vm.imageError}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73497810","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Widgets/ImageStatic.vue
// module id = null
// module chunks = 